module.exports = __webpack_public_path__ + "static/img/jieqianmll.bf59125.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/jieqianmll.png
// module id = 330
// module chunks = 32